import * as React from 'react';
import { HTMLAttributes, PureComponent } from 'react';
import { omit } from '@tolkam/lib-utils';
import { classNames } from '@tolkam/lib-utils-ui';
import Animatable from '@tolkam/react-animatable';
import './styles';

class Loader extends PureComponent<IProps, IState> {

    public static defaultProps = {
        delay: 1000,
    };

    /**
     * @type IState
     */
    public state = {
        show: false,
    };

    protected tid: any;

    /**
     * @inheritDoc
     */
    public componentDidMount(): void {
        this.update(this.props.show);
    }

    /**
     * @inheritDoc
     */
    public componentDidUpdate(): void {
        this.update(this.props.show);
    }

    /**
     * @inheritDoc
     */
    public componentWillUnmount(): void {
        this.clear();
    }

    /**
     * @inheritDoc
     */
    public render() {
        const { props, state } = this;
        const { circle } = props;
        const elProps = omit(props, ['show', 'circle', 'delay', 'holdPlace']) as any;

        const baseClass = 'jc-loader';
        elProps.className = classNames(baseClass, {
            ['-line']: !circle,
            ['-circle']: circle,
            ['-placeholder']: props.holdPlace,
        }, props.className);

        return <Animatable show={state.show} keepMounted classPrefix="">
            <span {...elProps}>
                <span className="body">
                    {circle && <svg viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" /></svg>}
                </span>
            </span>
        </Animatable>;
    }

    /**
     * Updates internal state
     *
     * @param show
     */
    protected update(show: boolean) {
        const that = this;
        const { delay } = that.props;
        const cb = () => that.setState({show});

        that.clear();

        if(that.state.show === show) {
            return;
        }

        if(delay && show) {
            that.tid = setTimeout(cb, delay);
        } else {
            cb();
        }
    }

    /**
     * Clears timeout
     *
     * @return void
     */
    protected clear = () => {
        clearTimeout(this.tid);
    }
}

interface IState {
    show: boolean;
}

interface IProps extends HTMLAttributes<HTMLSpanElement> {
    show: boolean;
    circle?: boolean;
    delay?: number;
    holdPlace?: boolean;
}

export default Loader;
